import React, {useState, forwardRef, useImperativeHandle} from "react";

export default forwardRef((props, ref) => {
    const [distance, setDistance] = useState({});
    useImperativeHandle(ref, () => ({
        updateDistanceData(distance) {
            setDistance(distance);
        }
    }));
    return (
        <div className={'row'}>
            <div className={"col-md-6 col-lg-6"}>
                Distance From location - {distance.distance}
            </div>
            <div className={"col-md-6 col-lg-6"}>
                Arrival Time to Location - {distance.time}
            </div>
        </div>
    )
});
